import { useCallback, useState } from 'react';

export default function useLocalStorage(key: string, initialValue: unknown) {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
      return initialValue;
    }

    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = useCallback(
    (value: unknown) => {
      if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
        return;
      }
      window.localStorage.setItem(key, JSON.stringify(value));
      setStoredValue(value);
    },
    [setStoredValue, key]
  );

  return [storedValue, setValue];
}
